<template>
  <div style="padding: 10px; width: 100%">
    <div
      style="
        display: block;
        margin-left: auto;
        margin-right: auto;
        margin-top: 20px;
      "
    >
      {{ workDate | formatDate }}<i class="pi pi-calendar"></i>
    </div>
    <div v-if="!showDamagePage">
      <b>{{ $t("WorkRegistrationForm.TravelTime") }}</b>
    </div>
    <div v-else>
      <b>{{ $t("WorkRegistrationForm.DamageTitle") }}</b>
    </div>
    <div v-if="!showDamagePage">
      <div v-if="!addTimeManually">
        <div class="row">
          <div class="col-6">
            <span>{{ $t("WorkRegistrationForm.StartTime") }}</span>
            <br />
            <label
              ><b>{{
                this.selectedStartTime
                  ? moment(selectedStartTime).format("HH:mm")
                  : " --:-- "
              }}</b></label
            >
          </div>
          <div class="col-6">
            <span>{{ $t("WorkRegistrationForm.EndTime") }}</span>
            <br />
            <label
              ><b>{{
                this.selectedEndTime
                  ? moment(selectedEndTime).format("HH:mm")
                  : " --:-- "
              }}</b></label
            >
          </div>
        </div>
        <div class="row">
          <div class="col-6" style="padding: 10px">
            <div class="div-field">
              <button
                :disabled="selectedStartTime"
                class="custom-mobile-button"
                @click="startActivity()"
              >
                {{ $t("WorkRegistrationForm.Start") }}
              </button>
            </div>
          </div>
          <div class="col-6" style="padding: 10px">
            <div class="div-field">
              <button
                :disabled="selectedEndTime"
                class="custom-mobile-button"
                @click="stopActivity()"
              >
                {{ $t("WorkRegistrationForm.Stop") }}
              </button>
            </div>
          </div>
        </div>
      </div>

      <div v-else>
        <div class="row">
          <div class="col-6">
            <span>{{ $t("WorkRegistrationForm.StartTime") }}</span>
            <div class="div-field">
              <datetime
                v-bind:type="isEnabledMidnightOption() ? 'datetime' : 'time'"
                v-model="selectedStartTime"
                v-bind:format="isEnabledMidnightOption() ? 'dd/HH:mm' : 'HH:mm'"
                input-style="text-align:center"
                class="theme-blue"
                v-bind:backdrop-click="false"
                :min-datetime="isEnabledMidnightOption() ? minDatetime : null"
                :max-datetime="isEnabledMidnightOption() ? maxDatetime : null"
                input-id="inputStartTime"
                @input="onSelectStartTime"
              >
              </datetime>
            </div>
          </div>
          <div class="col-6">
            <span>{{ $t("WorkRegistrationForm.EndTime") }}</span>
            <div class="div-field">
              <datetime
                v-bind:type="isEnabledMidnightOption() ? 'datetime' : 'time'"
                v-model="selectedEndTime"
                v-bind:format="isEnabledMidnightOption() ? 'dd/HH:mm' : 'HH:mm'"
                input-style="text-align:center"
                class="theme-blue"
                v-bind:backdrop-click="false"
                :min-datetime="isEnabledMidnightOption() ? minDatetime : null"
                :max-datetime="isEnabledMidnightOption() ? maxDatetime : null"
              >
              </datetime>
            </div>
          </div>
        </div>
      </div>

      <div>
        <div style="float: left; margin-top: 20px; margin-bottom: 10px">
          <Checkbox
            v-model="isDriver"
            @change="onDriverChange"
            :binary="true"
          />
          <label style="margin-bottom: 0px; margin-left: 5px">{{
            $t("WorkRegistrationForm.Driver")
          }}</label>
        </div>

        <Dropdown
          v-model="selectedCarType"
          :options="carTypes"
          optionLabel="name"
          :filter="true"
          :showClear="true"
          :placeholder="$t('WorkRegistrationForm.SelectVehicle')"
          @change="onSelectCarType()"
        >
          <template #option="slotProps">
            <div
              v-bind:class="{
                recent: slotProps.option.isRecent,
              }"
            >
              {{ slotProps.option.name }}
            </div>
          </template>
        </Dropdown>
        <div
          v-if="
            selectedCarType &&
            selectedCarType.id != 0 &&
            selectedCarType.id != -1
          "
          style="margin-top: 10px"
        >
          <div
            style="float: left; font-weight: bold; text-decoration: underline"
          >
            {{ $t("WorkRegistrationForm.VehicleSpecifications") }}
          </div>
          <br />
          <div>
            <table>
              <tr>
                <td style="float: left">
                  {{ $t("WorkRegistrationForm.OwnWeight") }}
                </td>
                <td>
                  {{
                    selectedCarType.ownWeight
                      ? selectedCarType.ownWeight + " kg"
                      : "not specified"
                  }}
                </td>
              </tr>
              <tr>
                <td style="float: left">
                  {{ $t("WorkRegistrationForm.LoadCapacity") }}
                </td>
                <td>
                  {{
                    selectedCarType.loadCapacity
                      ? selectedCarType.loadCapacity + " kg"
                      : "not specified"
                  }}
                </td>
              </tr>
              <tr>
                <td style="float: left">
                  {{ $t("WorkRegistrationForm.TowingCapacity") }}
                </td>
                <td>
                  {{
                    selectedCarType.towingCapacity
                      ? selectedCarType.towingCapacity + " kg"
                      : "not specified"
                  }}
                </td>
              </tr>
            </table>
          </div>
        </div>
        <div v-if="selectedCarType && (isDriver || selectedCarType.id == 0)">
          <input
            v-if="selectedCarType.id == 0 || selectedCarType.id == -1"
            v-model="distance"
            class="form-control"
            type="number"
            :placeholder="$t('WorkRegistrationForm.KmDriven')"
            style="margin-top: 10px; margin-bottom: 10px"
          />
          <input
            v-if="selectedCarType.id == 0 || selectedCarType.id == -1"
            v-model="licensePlate"
            class="form-control"
            type="text"
            :placeholder="$t('WorkRegistrationForm.LicensePlate')"
            style="margin-top: 10px; margin-bottom: 10px"
          />
        </div>
        <br />
        <div v-if="workRegistration && editDamage && isDriver">
          <label for="dmgdescription" style="float: left">{{
            $t("WorkRegistrationForm.DamageText")
          }}</label>
          <input
            type="text"
            id="dmgdescription"
            v-model="damageDescription"
            :disabled="false"
            style="width: 100%; min-height: 200px"
          />
          <span style="float: left; margin-top: 15px">{{
            $t("WorkRegistrationForm.DamageForm")
          }}</span>
          <button class="custom-mobile-button" @click="openDamageForm()">
            {{ $t("WorkRegistrationForm.DamageFormButton") }}
          </button>
        </div>
        <button
          v-if="!addTimeManually"
          class="custom-mobile-button"
          @click="enterTimeManually()"
        >
          {{ $t("WorkRegistrationForm.EnterTimeManually") }}
        </button>
        <button class="custom-mobile-button" @click="checkDamage(true)">
          {{ $t("WorkRegistrationForm.Save") }}
        </button>
      </div>
    </div>
    <div v-else>
      <br /><br />
      <span style="float: left">{{
        $t("WorkRegistrationForm.DamageText")
      }}</span
      ><br />
      <textarea
        style="width: 100%; min-height: 200px"
        v-model="damageDescription"
      ></textarea>
      <span style="float: left; margin-top: 15px">{{
        $t("WorkRegistrationForm.DamageForm")
      }}</span>
      <button class="custom-mobile-button" @click="openDamageForm()">
        {{ $t("WorkRegistrationForm.DamageFormButton") }}
      </button>
      <button class="custom-mobile-button" @click="checkIfWorkDayExists()">
        {{ $t("WorkRegistrationForm.Save") }}
      </button>
    </div>
    <div v-if="showDamagePage">
      <button class="custom-mobile-button" @click="goBackFromDamagePage()">
        {{ $t("Confirmation.Cancel") }}
      </button>
    </div>
    <div v-else>
      <BackButton />
    </div>

    <Confirmation
      @confirmed="onConfirmDriver"
      :question="driverQuestion"
      :display="showConfirmationModalDriver"
      :showNoButton="true"
    />
    <Confirmation
      @confirmed="onConfirmDamage"
      :question="damageQuestion"
      :display="showDamageModal"
      :showNoButton="true"
    />
  </div>
</template>
<script>
import LocalStorageService from "../services/LocalStorageService";
import ProjectService from "../services/ProjectService";
import ActivityService from "../services/ActivityService";
import ObjectService from "../services/ObjectService";
import WorkRegistrationService from "../services/WorkRegistrationService";
import { formatDateTimeServer, formatDateServer } from "../utils";
import BackButton from "../components/common/BackButton";
import moment from "moment";
import WorkSlipService from "../services/WorkSlipService";
import WorkDayService from "../services/WorkDayService";
import Confirmation from "../components/common/Confirmation";

export default {
  name: "AddTravelTimeComponent",
  components: {
    BackButton,
    Confirmation,
  },
  props: {
    drivers: null,
    workRegistration: null,
    workDate: null,
    workDayEndTime: null,
  },
  workRegistrationService: null,
  activityService: null,
  projectService: null,
  localStorageService: null,
  workSlipService: null,
  workDayService: null,
  objectService: null,
  data() {
    return {
      showDriverModal: false,
      projects: null,
      selectedProject: null,
      activities: null,
      selectedActivity: null,
      remark: "",
      selectedTime: null,
      selectedRemarks: [],
      remarks: null,
      maxDatetime: null,
      minDatetime: null,
      workDayId: null,
      isWorkSlipEmployee: false,
      employee: null,
      workSlip: null,
      workSlips: null,
      maxWrEndTime: null,
      selectedWorkSlip: null,
      selectedStartTime: null,
      selectedEndTime: null,
      filteredActivities: null,
      showEndTimeDialog: false,
      workDay: null,
      addTimeManually: false,
      moment: moment,
      isDriver: false,
      carTypes: null,
      selectedCarType: null,
      driverQuestion: this.$t("WorkRegistrationForm.DriverQuestion"),
      showConfirmationModalDriver: false,
      distance: "",
      licensePlate: "",
      showDamageModal: false,
      damageQuestion: this.$t("WorkRegistrationForm.DamageQuestion"),
      saveDay: false,
      damageDescription: "",
      editDamage: false,
      showDamagePage: false,
      cancelDamage: false,
    };
  },
  created() {
    this.workRegistrationService = new WorkRegistrationService();
    this.activityService = new ActivityService();
    this.projectService = new ProjectService();
    this.localStorageService = new LocalStorageService();
    this.workSlipService = new WorkSlipService();
    this.workDayService = new WorkDayService();
    this.employee = this.localStorageService.getCurrentEmployee();
    this.objectService = new ObjectService();
    this.isWorkSlipEmployee = this.employee.isWorkSlipEmployee;
    this.editDamage = this.$route.query.editDamage;
    this.workDayId = this.$route.query.workDayId;
    this.workDate = this.$route.query.workDate;
    this.getProjectInfos();
    this.getActivityInfos();

    this.getCarsInfos();
    this.drivers = this.$route.query.drivers;
    this.addTimeManually = this.$route.query.addTimeManually
      ? this.$route.query.addTimeManually
      : false;
    this.selectedActivity = this.activities;
    this.workRegistration = this.$route.query.workRegistration;
    if (this.workRegistration) {
      this.isDriver = this.workRegistration.isDriver;
    } else {
      this.isEmployeeADriver();
    }

    if (this.workRegistration) {
         this.selectedStartTime = this.workRegistration.startTime;
      this.selectedEndTime = this.workRegistration.endTime
        ? this.workRegistration.endTime
        : null;
    }

    this.showDamagePage = this.$route.query.showDamagePage
      ? this.$route.query.showDamagePage
      : false;
    this.cancelDamage = this.$route.query.cancelDamage
      ? this.$route.query.cancelDamage
      : false;
  },
  mounted() {
    this.minDatetime = this.workDate;
    this.maxDatetime = moment(this.workDate)
      .add(1, "days")
      .add(23, "hours")
      .add(59, "minutes")
      .format("YYYY-MM-DD[T]HH:mm:00");
    this.getWorkDay();

    console.log(this.workDay);
  },
  methods: {
    getWorkRegistrationMaxEndTime() {
      this.workRegistrationService
        .getWorkRegistrationMaxEndTime(this.workDayId, this.employee.id)
        .then((response) => {
          let self = this;
          self.maxWrEndTime = response.data;
          if (this.workRegistration) {
            this.selectedStartTime = formatDateTimeServer(
              new Date(this.workRegistration.startTime)
            );
            if (this.workRegistration.endTime != null) {
              this.selectedEndTime = formatDateTimeServer(
                new Date(this.workRegistration.endTime)
              );
            } else if (this.addTimeManually) {
              this.selectedEndTime = formatDateTimeServer(
                new Date(this.workDayEndTime)
              );
            }
          } else if (this.addTimeManually) {
            const hours = new Date().getHours();
            const minutes = new Date().getMinutes();
            const startTime = new Date(this.workDate);
            startTime.setHours(hours);
            startTime.setMinutes(minutes);
            const dummyDate = new Date();
            if (self.maxWrEndTime) {
              this.selectedStartTime = formatDateTimeServer(self.maxWrEndTime);
              // var end = new Date(self.maxWrEndTime);
              // end.setHours(end.getHours() + 1);
              // this.selectedEndTime = formatDateTimeServer(end);
            } else {
              if (dummyDate.getDate() == startTime.getDate()) {
                this.selectedStartTime = formatDateTimeServer(startTime);
              }

              // var proposedEnd = new Date(startTime);
              // proposedEnd.setHours(proposedEnd.getHours() + 1);
              // this.selectedEndTime = formatDateTimeServer(end);
            }
            if (this.isEnabledMidnightOption() && !this.selectedStartTime) {
              this.hideStartTime();
            }
          }
        })
        .catch(() => {});
    },
    getWorkSlipOptions() {
      this.workSlipService
        .getWorkSlipOptions(this.workDate)
        .then((response) => {
          const result = response.data;
          if (result) {
            this.workSlips = result;
            if (this.workRegistration) {
              this.selectedWorkSlip = this.workSlips.find(
                (s) => s.value === this.workRegistration.workSlipNumber
              );
            }
          }
        })
        .catch(() => {});
    },
    getProjectInfos() {
      this.projectService
        .getProjectInfos()
        .then((response) => {
          const result = response.data;
          if (result) {
            this.projects = result.map((s) => {
              return {
                id: s.id,
                name: `${s.projectNumber} ${s.name}`,
                isRecent: s.isRecent,
              };
            });
            if (this.workRegistration) {
              this.selectedProject = this.projects.find(
                (s) => s.id === this.workRegistration.projectId
              );
            }
            if (this.isWorkSlipEmployee) this.getWorkSlipOptions();
          }
        })
        .catch(() => {});
    },
    onSelectProject() {
      this.selectedObject = null;
    },
    getActivityInfos() {
      this.activityService
        .getActivityInfos()
        .then((response) => {
          const result = response.data;
          if (result) {
            this.activities = result.map((s) => {
              return {
                id: s.id,
                name: s.name,
                descriptionRequired: s.descriptionRequired,
                remarks: s.remarks,
                defaultProjectId: s.defaultProjectId,
                isRecent: s.isRecent,
                activityCode: s.activityCode,
              };
            });
            if (this.workRegistration) {
              if (this.workRegistration.activityId != null) {
                this.selectedActivity = this.activities.find(
                  (s) => s.id === this.workRegistration.activityId
                );
              } else if (this.workRegistration.activityTypeId != null) {
                this.selectedActivity = this.activities.find(
                  (s) => s.id === this.workRegistration.activityTypeId
                );
              }
              this.remarks = this.selectedActivity.remarks;
              if (this.workRegistration) {
                this.remark = this.workRegistration.activityRemark || "";
                if (this.remark && this.remarks) {
                  this.remarks.forEach((s) => {
                    if (this.remark.indexOf(s.name) > -1) {
                      this.selectedRemarks.push(s);
                    }
                  });
                }
              }
            }
          }
          this.filteredActivities = this.activities.filter((activity) => {
            return activity.activityCode[0] != "1";
          });
          this.selectedActivity = this.activities.find(
            (item) => item.activityCode == "120.000.00.001"
          );
        })
        .catch(() => {});
    },
    onSelectActivity() {
      if (this.selectedActivity.defaultProjectId) {
        this.selectedProject = this.projects.find(
          (s) => s.id === this.selectedActivity.defaultProjectId
        );
      }
      this.remarks = this.selectedActivity.remarks;
      if (this.workRegistration) {
        this.remark = this.workRegistration.activityRemark || "";
        if (this.remark && this.remarks) {
          this.remarks.forEach((s) => {
            if (this.remark.indexOf(s.name) > -1) {
              this.selectedRemarks.push(s);
            }
          });
        }
      }
    },
    isEnabledMidnightOption() {
      let isMidnight = this.$route.query.isMidnight === true || false;
      if (isMidnight === true) return isMidnight;
      return (
        this.localStorageService.getCurrentEmployee().isEnabledMidnightOption ||
        false
      );
    },
    checkIfWorkDayExists() {
      if (
        !this.selectedStartTime
        // || (this.addTimeManually &&
        // document.getElementById("inputStartTime").style != null && document.getElementById("inputStartTime").style[0] == "text-indent")
      ) {
        this.$toast.add({
          severity: "warn",
          detail: "Please select start time.",
          life: 3000,
          closable: false,
        });
        return;
      }
      if (this.workDayId == 0) {
        this.workDayService.createWorkDay(this.workDate).then((response) => {
          this.workDayId = response.data.id;
          this.checkEmployeeType();
        });
      } else {
        this.checkEmployeeType();
      }
    },
    checkEmployeeType() {
      if (this.isWorkSlipEmployee) {
        this.saveWorkRegistration();
      } else {
        for (const wr of this.workDay.workRegistrations) {
          if (
            new Date(this.selectedStartTime).getTime() >=
              new Date(wr.startTime).getTime() &&
            new Date(this.selectedStartTime).getTime() <
              new Date(wr.endTime).getTime()
          ) {
            this.showEndTimeDialog = true;
            //return;
          }
        }
        this.saveWorkRegistration();
      }
    },
    saveWorkRegistration() {
      if (!this.checkIfFieldsAreCompleted()) {
        return;
      }
      let startTime = formatDateTimeServer(new Date(this.selectedStartTime));
      // ? formatDateTimeServer(new Date(this.selectedStartTime))
      // : null;
      if (!this.isEnabledMidnightOption()) {
        let dummyStartTime = new Date(this.workDay.workDate);
        dummyStartTime.setHours(new Date(this.selectedStartTime).getHours());
        dummyStartTime.setMinutes(
          new Date(this.selectedStartTime).getMinutes()
        );
        startTime = formatDateTimeServer(new Date(dummyStartTime));
      }

      let endTime = this.selectedEndTime;
      let dummyEndTime = new Date(this.workDay.workDate);
      if (
        this.selectedEndTime &&
        this.selectedEndTime != "" &&
        this.selectedEndTime != "Invalid date" &&
        !this.isEnabledMidnightOption()
      ) {
        dummyEndTime.setHours(new Date(this.selectedEndTime).getHours());
        dummyEndTime.setMinutes(new Date(this.selectedEndTime).getMinutes());
        endTime = formatDateTimeServer(new Date(dummyEndTime));
      } else if (
        this.selectedEndTime == "" ||
        this.selectedEndTime == "Invalid date" ||
        !this.selectedEndTime
      ) {
        endTime = null;
      } else {
        endTime = formatDateTimeServer(new Date(this.selectedEndTime));
      }
      if (!this.selectedStartTime) {
        this.$toast.add({
          severity: "warn",
          detail: "Please select start time.",
          life: 3000,
          closable: false,
        });
      }
      if (
        !this.workRegistrationService.validateTimes(
          formatDateTimeServer(startTime),
          formatDateTimeServer(endTime)
        )
      ) {
        return;
      }
      if (
        !endTime &&
        this.workDay &&
        this.workDay.workRegistrations &&
        this.workDay.workRegistrations.length > 1
      ) {
        var lastWrStartTime = new Date(
          this.workDay.workRegistrations[
            this.workDay.workRegistrations.length - 1
          ].startTime
        ).getTime();
        var lastWrEndTime = new Date(
          this.workDay.workRegistrations[
            this.workDay.workRegistrations.length - 1
          ].endTime
        ).getTime();
        var firstWrStartTime = new Date(
          this.workDay.workRegistrations[0].startTime
        ).getTime();
        var currentStartTime = new Date(startTime).getTime();
        if (lastWrEndTime) {
          if (
            currentStartTime < lastWrEndTime &&
            currentStartTime > firstWrStartTime
          ) {
            this.$toast.add({
              severity: "warn",
              detail:
                "Please select an endtime if you want to add a work registration between another work registrations.",
              life: 5000,
              closable: false,
            });
            return;
          }
        } else {
          if (
            currentStartTime < lastWrStartTime &&
            currentStartTime > firstWrStartTime
          ) {
            this.$toast.add({
              severity: "warn",
              detail:
                "Please select an endtime if you want to add a work registration between another work registrations.",
              life: 5000,
              closable: false,
            });
            return;
          }
        }
      }
      /*       let endTime = this.isWorkSlipEmployee
        ? formatDateTimeServer(new Date(this.selectedEndTime))
        : this.showEndTimeDialog
        ? formatDateTimeServer(new Date(this.selectedEndTime))
        : null; */
      this.showEndTimeDialog = false;
      if (
        this.selectedCarType.objectNumber != "OwnCar" &&
        this.selectedCarType.objectNumber != "ColeagueCar"
      ) {
        this.distance = null;
        this.licensePlate = null;
      }
      //if (this.workRegistrationService.validateTimes(startTime, endTime)) {
      let remark = `${this.selectedRemarks.map((s) => s.name).join(" | ")}`;
      const model = {
        projectId: this.selectedProject ? this.selectedProject.id : null,
        activityId: this.selectedActivity.id,
        startTime: startTime,
        endTime: endTime,
        activityRemark: remark,
        isWorkSlipEmployee: this.isWorkSlipEmployee,
        deviceId: this.localStorageService.getDeviceId(),
        workDayId: +this.workDayId,
        workSlipNumber: this.selectedWorkSlip
          ? this.selectedWorkSlip.workSlipNumber
          : null,
        orderNumber: this.selectedWorkSlip
          ? this.selectedWorkSlip.orderNumber
          : null,
        isDriver: this.isDriver,
        distance: this.distance ? this.distance : null,
        licensePlate: this.licensePlate ? this.licensePlate : null,
        objectNumber: this.selectedCarType.objectNumber
          ? this.selectedCarType.objectNumber
          : null,
        busNumber: this.selectedCarType.objectNumber
          ? this.selectedCarType.objectNumber
          : null,
        tripIncidents: this.damageDescription,
      };

      this.loader = this.$loading.show({});
      if (this.workRegistration) {
        model.id = +this.workRegistration.id;
        model.workDayId = this.workRegistration.workDayId;
        this.workRegistrationService
          .updateWorkRegistration(model)
          .then(() => {
            this.loader.hide();
            //if (this.saveDay)
            return this.$router.push({
              name: "work-day",
              query: { workDate: formatDateServer(this.workDate) },
            });
          })
          .catch(() => {
            this.loader.hide();
          });
      } else {
        this.workRegistrationService
          .createWorkRegistration(model)
          .then((response) => {
            this.loader.hide();
            this.workRegistration = response.data;
            //if (this.addTimeManually) {
            //if (this.saveDay)
            return this.$router.push({
              name: "work-day",
              query: { workDate: formatDateServer(this.workDate) },
            });
            //} else {
            //  return;
            //}
          })
          .catch(() => {
            this.loader.hide();
          });
      }

      //}
    },
    checkIfFieldsAreCompleted() {
      if (!this.selectedCarType) {
        this.$toast.add({
          severity: "warn",
          detail: "Please select a mean of transportation",
          life: 3000,
          closable: false,
        });
        return false;
      }
      if (
        this.selectedCarType &&
        (this.selectedCarType.id == 0 || this.selectedCarType.id == -1) &&
        (!this.distance || !this.licensePlate) &&
        this.isDriver &&
        this.selectedEndTime
      ) {
        this.$toast.add({
          severity: "warn",
          detail: "Please fill in the number of kilometers and license plate",
          life: 3000,
          closable: false,
        });
        return false;
      }
      if (this.showDamagePage && !this.damageDescription) {
        this.$toast.add({
          severity: "warn",
          detail:
            "Please fill in the damage, defects or details regarding the ride below",
          life: 3000,
          closable: false,
        });
        return false;
      }
      return true;
    },
    onSelectWorkSlip() {
      this.remark = "";
      if (!this.selectedWorkSlip) {
        this.filteredActivities = this.activities.filter((activity) => {
          return activity.activityCode[0] != "1";
        });
        this.selectedProject = null;
        return;
      }
      this.selectedProject = this.projects.find(
        (s) => s.id === this.selectedWorkSlip.projectId
      );
      this.selectedActivity = this.activities.find(
        (s) => s.id === this.selectedWorkSlip.activityId
      );
      //this.remark = this.selectedWorkSlip.workType;
      this.filteredActivities = this.activities.filter((activity) => {
        return activity.activityCode[0] == "1";
      });
    },
    getWorkDay() {
      const workDate = formatDateServer(this.workDate);
      if (
        new Date(workDate).getTime() !=
        new Date(new Date().setHours(0, 0, 0, 0)).getTime()
      ) {
        this.addTimeManually = true;
      }
      this.workDayService.getWorkDay(workDate).then((res) => {
        this.workDay = res.data;
        this.getWorkRegistrationMaxEndTime();
        // this.workDay.workRegistrations.forEach((s) => {
        //   if (s.activityTypeId == 182 && s.projectId == 9155) {
        //     let remarks = s.description.split("||");
        //     remarks.forEach((value) => {
        //       if (value.includes("Damage: ")) {
        //         this.damageDescription = value.substring(
        //           value.indexOf("Damage: ") + 8,
        //           value.length - 1
        //         );
        //       }
        //       if (value.includes("Car: ")) {
        //         this.selectedCarType = this.carTypes.find(
        //           (carType) =>
        //             carType.name ==
        //             value.substring(
        //               value.indexOf("Car: ") + 5,
        //               value.length - 1
        //             )
        //         );
        //       }
        //       if (value.includes("Distance: ")) {
        //         this.distance = value.substring(
        //           value.indexOf("Distance: ") + 10,
        //           value.length - 1
        //         );
        //       }
        //       if (value.includes("LicensePlate: ")) {
        //         this.licensePlate = value.substring(
        //           value.indexOf("LicensePlate: ") + 14,
        //           value.length - 1
        //         );
        //       }
        //       if (value.includes(`Driver: ${this.employee.name}`)) {
        //         this.isDriver = true;
        //       }
        //     });
        //   }
        // });
      });
    },
    // isDriverCheckBoxDisabled() {
    //   if (this.selectedCarType) {
    //     if (this.selectedCarType.id == -1) {
    //       this.isDriver = false;
    //       this.workSlipService.changeEmployeeDriverStatus(
    //         this.isDriver,
    //         this.workDate
    //       );
    //       return true;
    //     }
    //   }
    //   return false;
    // },
    onSelectedEndTime(event) {
      //this.showEndTimeDialog = false;
      this.selectedEndTime = event.value;
      this.saveWorkRegistration();
    },
    startActivity() {
      if (!this.checkIfFieldsAreCompleted()) {
        return;
      }
      this.selectedStartTime = this.getWorkDayWithCurrentTime();
      this.selectedStartTime = moment(this.selectedStartTime).toISOString();
      this.selectedStartTime = formatDateTimeServer(this.selectedStartTime);
      this.checkDamage();
    },
    stopActivity() {
      let currentDate = this.getWorkDayWithCurrentTime();
      if (
        new Date(currentDate).getTime() <=
          new Date(this.selectedStartTime).getTime() &&
        this.selectedStartTime
      ) {
        this.$toast.add({
          severity: "warn",
          detail: "End time must be greater than start time",
          life: 3000,
          closable: false,
        });
      } else {
        this.selectedEndTime = currentDate;
        this.selectedEndTime = moment(this.selectedEndTime).toISOString();
        this.selectedEndTime = formatDateTimeServer(this.selectedEndTime);
        if (!this.checkIfFieldsAreCompleted()) {
          this.selectedEndTime = null;
          return;
        }
        this.checkDamage();
      }
    },
    onDriverChange() {
      //this.isDriver = !this.isDriver;
      if (this.isDriver && this.isWorkSlipEmployee) {
        this.showConfirmationModalDriver = true;
      }
    },
    onSelectCarType() {},
    enterTimeManually() {
      this.addTimeManually = !this.addTimeManually;
      this.getWorkRegistrationMaxEndTime();
    },
    onConfirmDriver(value) {
      this.showConfirmationModalDriver = false;
      if (value) {
        //const description = `Driver: ${this.employee.name}`;
        //this.remark = description;
        //this.workSlipService.changeEmployeeDriverStatus(true, this.workDate);
      } else {
        //this.workSlipService.changeEmployeeDriverStatus(false, this.workDate);
        this.isDriver = false;
        this.remark = "";
      }
    },
    onConfirmDamage(value) {
      this.showDamageModal = false;
      this.saveDay = true;
      if (value) {
        this.showDamagePage = true;
      } else {
        this.checkIfWorkDayExists();
      }
    },
    getWorkDayWithCurrentTime() {
      let workDate = new Date(this.workDate);
      workDate.setHours(new Date().getHours());
      workDate.setMinutes(new Date().getMinutes());
      return workDate;
    },
    openDamageForm() {
      window.open(
        "https://webclient.moreapp.com/form/5e6a31c98c6ab75137268d0d",
        "_blank"
      );
    },
    checkDamage(checkFields = false) {
      if (checkFields && !this.checkIfFieldsAreCompleted()) {
        return;
      }
      if (
        this.isDriver &&
        !this.editDamage &&
        this.selectedStartTime &&
        this.selectedEndTime &&
        this.selectedEndTime != "" &&
        this.selectedEndTime != "Invalid date"
      ) {
        this.showDamageModal = true;
      } else {
        this.saveDay = true;
        this.checkIfWorkDayExists();
      }
    },
    checkTimes() {
      if (
        this.workRegistrationService.validateTimes(
          formatDateTimeServer(this.selectedStartTime),
          formatDateTimeServer(this.selectedEndTime)
        ) &&
        this.selectedStartTime
      ) {
        if (this.isDriver && !this.editDamage) {
          this.showDamageModal = true;
        } else {
          this.saveDay = true;
          this.checkIfWorkDayExists();
        }
      } else {
        this.$toast.add({
          severity: "warn",
          detail: "Please select start time.",
          life: 3000,
          closable: false,
        });
      }
    },
    onSelectStartTime() {
      if (
        document.getElementById("inputStartTime") &&
        document.getElementById("inputStartTime").style[0] == "text-indent"
      )
        document.getElementById("inputStartTime").style = "text-align: center;";
    },
    hideStartTime() {
      if (document.getElementById("inputStartTime") == null) {
        setTimeout(() => this.hideStartTime(), 1000);
      } else {
        this.selectedStartTime = this.minDatetime;
        document.getElementById("inputStartTime").style = "text-indent: -99em;";
      }
    },
    getCarsInfos() {
      this.objectService.getCarsInfos().then((response) => {
        this.carTypes = [
          {
            id: 0,
            loadCapacity: null,
            name: this.$t("WorkRegistrationForm.OwnCar"),
            ownWeight: null,
            towingCapacity: null,
            objectNumber: "OwnCar",
          },
          {
            id: -1,
            loadCapacity: null,
            name: this.$t("WorkRegistrationForm.ColleagueCar"),
            ownWeight: null,
            towingCapacity: null,
            objectNumber: "ColeagueCar",
          },
        ];
        response.data.forEach((car) => this.carTypes.push(car));
        this.workSlipService.getAssignedBus(this.workDate).then((response) => {
          if (response.data != null && response.data != 0) {
            this.selectedCarType = this.carTypes.find(
              (bus) => bus.id == response.data
            );
          }
        });
        if (this.workRegistration) {
          //  let remarks = "";
          //   if (this.workRegistration.activityRemark != null) {
          //     remarks = this.workRegistration.activityRemark.split("||");
          //   } else {
          //     remarks = this.workRegistration.description.split("||");
          //   }
          //   remarks.forEach((value) => {
          //     if (value.includes("Damage: ")) {
          //       this.damageDescription = value.substring(
          //         value.indexOf("Damage: ") + 8,
          //         value.length - 1
          //       );
          //       this.editDamage = true;
          //     }
          //     if (value.includes("Car: ")) {
          //       this.selectedCarType = this.carTypes.find(
          //         (carType) =>
          //           carType.id ==
          //           value.substring(value.indexOf("Car: ") + 5, value.length - 1)
          //       );
          //     }
          //     if (value.includes("Distance: ")) {
          //       this.distance = value.substring(
          //         value.indexOf("Distance: ") + 10,
          //         value.length - 1
          //       );
          //     }
          //     if (value.includes("LicensePlate: ")) {
          //       this.licensePlate = value.substring(
          //         value.indexOf("LicensePlate: ") + 14,
          //         value.length - 1
          //       );
          //     }
          //     if (value.includes(`Driver: ${this.employee.name}`)) {
          //       this.isDriver = true;
          //     }
          //   });
          if (this.workRegistration.distance) {
            this.distance = this.workRegistration.distance;
          }
          if (this.workRegistration.busNumber) {
            this.selectedCarType = this.carTypes.find(
              (bus) => bus.objectNumber == this.workRegistration.busNumber
            );
          }
          if (this.workRegistration.licensePlate) {
            this.licensePlate = this.workRegistration.licensePlate;
          }
          this.damageDescription = this.workRegistration.tripIncidents;
        }
      });
    },
    isEmployeeADriver() {
      this.workSlipService.isEmployeeADriver(this.workDate).then((response) => {
        this.isDriver = response.data;
      });
    },
    goBackFromDamagePage() {
      if (this.cancelDamage) {
        return this.$router.push({
          name: "work-day",
          query: { workDate: formatDateServer(this.workDate) },
        });
      }
      this.showDamagePage = false;
    },
  },
};
</script>
<style scoped>
.vdatetime >>> .vdatetime-input {
  width: 50%;
}
.div-field {
  margin-top: 10px;
  width: 100%;
}
.p-listbox {
  width: 100%;
}
.p-listbox-item {
  padding: 10px;
}
.p-inputtextarea {
  width: 100%;
}
.recent {
  color: #019ee9 !important;
}
</style>
